export default __webpack_public_path__ + "static/media/poster2.d1e71836.jpg";